<template>
  <v-dialog
  persistent
  v-model="show"
  max-width="400px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-form v-model="valid">
      <v-container class="modal-pad">
        <v-layout row wrap>
          <v-flex xs12 style="height:80px;">
            <span class="subheading">Please enter an email address.</span>
            <p>We need the customer's email address so we can auto-chase the invoice.</p>
          </v-flex>
        </v-layout>
        <v-layout column pt-2>
          <v-flex xs12>
            <v-combobox
            name="invoice_ref_ensure"
            id="invoice_ref_ensure"
            label="To:"
            v-model="addedemailList"
            multiple
            chips
            :items="emailList"
            placeholder="Enter one or more recipient email addresses"
            dense
            deletable-chips
            autofocus
            required
            ref="focus"
            :rules="[emailRules]"
            validate-on-blur
            :delimiters="[',', ';', ' ']"
            @change="$refs.emailForm.validate();"
          ></v-combobox>
          </v-flex>
        </v-layout>
        <v-layout align-end justify-end row fill-height>
          <v-btn
            style="margin-left:0; margin-right:0;"
            depressed
            color="primary"
            @click="onCloseDialog">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn style="margin-left:0; margin-right:0;"  depressed color="accent" @click="onSaveChanges" :disabled='!valid'>Save</v-btn>
        </v-layout>
      </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'GetInvoiceToEmail',
  props: {
    emailList: Array,
    value: Boolean
  },
  data () {
    return {
      valid: false,
      addedemailList: this.emailList,
      emailRules:
        v => {
          if (!v || v.length < 1) {
            return 'Enter one or more valid emails'
          } else if (v.length > 0) {
            for (let i = 0; i < v.length; i++) {
              if (!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
                return 'Enter one or more valid emails'
              }
            }
            return true
          } else {
            return true
          }
        },
      resolve: null,
      reject: null,
      group: this.$store.getters.group
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    emailEntered () {
      if (this.addedemailList.length > 0 || this.addedemailList === 'undefined') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    show (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    }
  },
  methods: {
    open () {
      // if there is an invoie_ref or we are using autoincrement then pass the validation now
      if (this.emailEntered || !this.group.sendChasers) {
        return true
      }
      // else lets show the dialog and get an invoice_ref
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    onCloseDialog () {
      this.resolve(false)
      // hide the dialog
      this.show = false
      // and reset the inputs to their original values
      this.addedemailList = this.emailList
    },
    onSaveChanges () {
      this.$emit('return-emailList-details', {
        emailList: this.addedemailList
      })
      this.resolve(true)
      this.show = false
    }
  }

}
</script>
